import React, { useState } from "react";
import { ExpenseItemSearchRequest } from "../@types";
import ExpenseDashTab from "../refactor/ExpenseDashTab";
import IncomeDashTab from "../refactor/IncomeDashTab";
import FinanceFilterComponent from "../ui/FinanceFilterComponent";
import ExportExpenseModal from "./ExportExpenseModal";
import ExportIncomeModal from "./ExportIncomeModal";

interface VehicleIncomeAndExpenseProps {
  id?: string;
  idType: string;
}

const VehicleIncomeAndExpense: React.FC<VehicleIncomeAndExpenseProps> = ({
  id,
  idType,
}) => {
  const [activeTab, setActiveTab] = useState("income");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    category: "",
  });

  const requestBody: ExpenseItemSearchRequest = {
    pageNumber: currentPage,
    pageSize: pageSize,
    keyword: searchTerm || undefined,
    startDate: filterData.startDate || undefined,
    endDate: filterData.endDate || undefined,
    category: filterData.category || undefined,
    vehicleId: idType === "vehicle" ? id : undefined,
    driverId: idType === "driver" ? id : undefined,
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setCurrentPage(0);
  };

  const TabContent = () => {
    if (activeTab === "income") {
      return (
        <IncomeDashTab
          requestBody={requestBody}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
        />
      );
    } else if (activeTab === "expense") {
      return (
        <ExpenseDashTab
          requestBody={requestBody}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
        />
      );
    }
    return null;
  };

  return (
    <div className="mt-5">
      {/* Search */}
      <div className="flex items-center justify-between gap-2 mb-4">
        <nav className="flex px-2 whitespace-nowrap min-w-max">
          <button
            onClick={() => setActiveTab("income")}
            className={`px-3 py-1 mr-4 font-medium text-[16px] transition-colors ${
              activeTab === "income"
                ? "bg-primary/20 text-primary rounded-[8px]"
                : "border-transparent text-pColor hover:text-hColor"
            }`}
          >
            Income
          </button>
          <button
            onClick={() => setActiveTab("expense")}
            className={`px-3 py-1 mr-4 font-medium text-[16px] transition-colors ${
              activeTab === "expense"
                ? "bg-primary/20 text-primary rounded-[8px]"
                : "border-transparent text-pColor hover:text-hColor"
            }`}
          >
            Expense
          </button>
        </nav>
        <div className="flex gap-2">
          <FinanceFilterComponent onApplyFilters={setFilterData} />

          {activeTab === "expense" ? (
            <ExportExpenseModal vehicleId={id} />
          ) : (
            <ExportIncomeModal vehicleId={id} />
          )}
        </div>
      </div>
      <TabContent />
    </div>
  );
};

export default VehicleIncomeAndExpense;
